import { ReactNode } from "react";
import { Tooltip } from "react-tooltip";
import styles from "./TooltipWrapper.module.scss";

interface TooltipWrapperProps {
  id: string;
  content: string;
  arabicDir?: boolean;
  children: ReactNode;
}

const TooltipWrapper = ({
  id,
  content,
  children,
  arabicDir,
}: TooltipWrapperProps) => {
  return (
    <div>
      <div
        style={{ direction: arabicDir ? "ltr" : "rtl" }}
        data-tooltip-id={id}
        data-tooltip-content={content}
        data-tooltip-place="bottom"
        className={styles.tooltip_wrapper}>
        {children}
      </div>
      <Tooltip
        style={{ direction: arabicDir ? "ltr" : "rtl" }}
        className={styles.tooltip}
        place="bottom"
        id={id}
        content={content}
      />
    </div>
  );
};

export default TooltipWrapper;
